export default {
  state: {
    currentFilter: 'az',
  },
  mutations: {
    SET_CURRENT_FILTER(state, value) {
      state.currentFilter = value
    },
  },

  getters: {
    GET_CURRENT_FILTER(state) {
      return state.currentFilter
    },
  },
}
